<template>
  <el-form
    v-if="reloadForm"
    ref="ruleForm"
    :rules="baseRules"
    :model="value"
    :validate-on-rule-change="false"
    :disabled="disabled"
    :label-width="labelWidth || 'auto'"
  >
    <el-row :gutter="10">
      <div v-for="(option, index) in options" :key="index">
        <h5 style="margin-left: 40px" v-if="option.type == 'subTitle'">{{ option.label }}</h5>
        <el-col v-else :span="option.span || colSpan">
          <el-form-item
            v-if="option.children && option.children.length"
            :label="option.langKey ? $t(option.langKey) : option.label"
            :prop="option.prop"
            :class="getClass(option)"
            :required="!disabled ? option.required || false : false"
          >
            <el-row>
              <el-col
                v-for="(childOption, childIndex) in option.children"
                :class="childIndex > 0 ? 'p-l' : ''"
                :key="childIndex"
                :span="childOption.span || 12"
              >
                <base-form-item
                  :relationOption="relationOption(childOption, childIndex)"
                  :option="childOption"
                  :value="value"
                  @input="handleChange"
                  @change="handleBlurChange"
                  :disabled="disabled"
                >
                </base-form-item>
              </el-col>
            </el-row>
          </el-form-item>
          <base-form-item
            v-else
            :relationOption="relationOption(option, index)"
            :option="option"
            :value="value"
            :className="getClass(option)"
            @input="handleChange"
            @change="handleBlurChange"
            @goRouter="goRouter"
            :disabled="disabled"
          >
          </base-form-item>
        </el-col>
      </div>
    </el-row>
  </el-form>
</template>

<script>
  import baseFormItem from '@/components/form/base-form-item';
  import { toFormErrorTop } from '@/common/js/util';
  import XEUtils from 'xe-utils';
  export default {
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      /**
       * {
       *  type: '', // 类型
       *  label: '', // 文案
       *  required: true/false, // 是否必填
       *  children: [], // 一个form-item多个form-item
       *  message: '', // 提示文案，可不传，根据label生成
       *  validator: function() {}, // 可传自定义验证函数
       *  disabled
       *  等等，请参考base-form-item里面的类型
       *  ...
       * }
       */
      options: {
        type: Array,
        default: () => [],
      },
      labelWidth: {
        type: String,
        default: '',
      },
      // 多少个文案换行，自己根据labelWidth定
      maxLabelLength: {
        type: Number,
        default: 6,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      colSpan: {
        type: Number,
        default: 6,
      },
    },
    components: {
      baseFormItem,
    },
    watch: {
      options: {
        handler(newName, oldName) {
          // 用于
          if (!XEUtils.isEqual(newName, oldName)) {
            this.reloadForm = false;
            this.reloadForm = true;
          }
        },
        deep: true, //为true，表示深度监听，这时候就能监测到a值变化
      },
    },
    data() {
      return {
        reloadForm: true,
      };
    },
    computed: {
      baseRules() {
        if (this.disabled) {
          return {};
        }
        return this.getRules();
      },
    },
    methods: {
      goRouter(router) {
        this.$emit('goRouter', router);
      },
      clear(val) {
        this.$nextTick(() => {
          this.$refs['ruleForm'].clearValidate(val);
        });
      },
      getClass(option) {
        const label = option.langKey ? this.$t(option.langKey) : option.label;
        const length = this.maxLabelLength;
        const maxLabelLength = this.$store.getters.language == 'zh_CN' ? length : length * 2;
        return label && label.length > maxLabelLength ? 'propClass' : '';
      },
      relationOption(option, index) {
        let obj = {};
        if (option.type == 'startDate') {
          obj = this.options[index + 1];
        }
        if (option.type == 'endDate') {
          obj = this.options[index - 1];
        }
        return obj;
      },
      handleChange(newValue, prop) {
        this.$emit(
          'input',
          {
            ...this.value,
            ...newValue,
          },
          prop
        );
      },
      handleBlurChange(newValue, prop) {
        this.$emit(
          'change',
          {
            ...this.value,
            ...newValue,
          },
          prop
        );
      },
      handleSubmit() {
        return new Promise((resolve, reject) => {
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              resolve();
            } else {
              // 验证错误跳转至第一个错误提示得地方
              toFormErrorTop();
              reject();
              return false;
            }
          });
        });
      },
      // 生成默认验证规则
      getRules() {
        const inputTip = this.$t('search.input');
        const selectTip = this.$t('search.choose');
        const rules = {};
        const _this = this;
        function each(options) {
          options.forEach((item) => {
            if (item.required && item.prop) {
              const inputArr = ['sixNumber', 'input', 'textarea', 'inputNumber'];
              const label = item.langKey ? _this.$t(item.langKey) : item.label;
              const messageT = item.messageKey ? _this.$t(item.messageKey) : item.message;
              const message =
                messageT ||
                (inputArr.indexOf(item.type) > -1 ? inputTip : selectTip) + (label || '');
              const required =
                typeof item.required === 'function' ? item.required(_this.value) : item.required;
              let obj = [
                {
                  required: required,
                  message: message,
                  trigger: inputArr.indexOf(item.type) > -1 ? 'blur' : 'change',
                },
              ];
              if (item.ruleType === 'object') {
                obj.validator = function (rule, value, callback) {
                  if (item.validatorKey) {
                    callback();
                  } else {
                    callback(new Error(message));
                  }
                };
              }
              if (item.validator) {
                obj.push({
                  validator: item.validator,
                  trigger: inputArr.indexOf(item.type) > -1 ? 'blur' : 'change',
                });
              }
              rules[item.prop] = obj;
            } else {
              const obj = {};
              if (item.validator) {
                obj.validator = item.validator;
                rules[item.prop] = [obj];
              }
            }

            if (item.children && item.children.length) {
              each(item.children);
            }
          });
        }
        each(this.options);
        console.log('自定义的校验规则', rules);
        return rules;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-col {
    height: 48px;
  }
  .el-col-24 {
    margin-bottom: 18px;
  }
  ::v-deep .propClass .el-form-item__label {
    line-height: 18px;
  }
</style>
